export default { sha: '90de411980170c5b35389253bd9e3784b9e9050c', buildNumber: 'undefined' }
